export default __webpack_public_path__ + "static/media/section2a-card1img.09bcd171.svg";